import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { animated, useSpring } from "react-spring";
import { Captain } from "../../../types/Captain";
import {
    captainActivity,
    captainBannerContainer,
    captainFirstName,
    captainLastName,
    flagBox,
} from "./captainBannerStyles";

interface CaptainBannerProps {
    captain: Captain;
    triggerBanner: boolean;
}

const CaptainBanner: React.FC<CaptainBannerProps> = ({
    captain,
    triggerBanner,
}) => {
    const bannerAnimation = useSpring({
        from: { transform: "translateY(100%)", opacity: 0 },
        to: {
            transform: triggerBanner ? "translateW(0%)" : "translateY(100%)",
            opacity: triggerBanner ? 1 : 0,
        },
        config: { tension: 100, friction: 30 },
    });

    return (
        <Box
            component={animated.div}
            style={bannerAnimation}
            sx={captainBannerContainer}
        >
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{ height: "100%" }}
            >
                <Box>
                    <Typography variant="subtitle2" sx={captainFirstName}>
                        {captain.firstName}
                    </Typography>
                    <Typography variant="h4" sx={captainLastName}>
                        {captain.lastName}
                    </Typography>
                    {captain.yearsAsCaptain && (
                        <Typography variant="caption" sx={captainActivity}>
                            {captain.yearsAsCaptain}
                        </Typography>
                    )}
                </Box>
                <Box
                    component="img"
                    sx={flagBox}
                    alt={`${captain.firstName} ${captain.lastName}`}
                    src="/images/icons/hsv-nxp-vertical.png"
                />
            </Stack>
        </Box>
    );
};

export default CaptainBanner;
